var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    this.$store.getters['module_visit/mapOpen'] ||
      this.$store.getters['module_visit/cardOpen']
  )?_c('div',{staticClass:"Panel"},[(this.$store.getters['module_visit/mapOpen'])?_c('Map'):_vm._e(),(this.$store.getters['module_visit/cardOpen'])?_c('Card'):_vm._e(),_c('div',{staticClass:"CloseButton",on:{"click":function($event){return _vm.ClosePanel()}}},[_c('div',{staticClass:"CloseButton__Icon"})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }